<template>
  <div style="background: darkred; padding: 10px; height: 100%; border-radius: 12.5px">
    <!-- widgetType {{ widgetType }}
    <h4 style="height:30px;overflow:auto;">widget {{ widget }}</h4>
    <div style="height:60px;overflow:auto;color:darkorange;background:black;">widgetDetail.dueTextSummary {{ widgetDetail.dueTextSummary }}</div>
    <h4 style="height:100%;color:cyan;">widgetDetail.workItemRecords {{ widgetDetail.workItemRecords[0] }}</h4> -->

    <!--! TONY's -->
    <div style="background: #eef8ef; padding: 3px; overflow: auto; border-radius: 6.25px; border: 2px solid #eef8ef">
      <!-- <div style="background:#c6d9c8; padding:3px; overflow:auto;border-radius:6.25px;	border: 2px solid #dcf1de;"> -->

      widgetDetail {{ widgetDetail }}
      <DxPieChart
        id="pie"
        :data-source="widgetDetail"
        resolve-label-overlapping="shift"
        :type="widget.widgetType === 1 ? 'pie' : 'doughnut'"
        :title="widget.name"
        palette="Dark Violet"
        @point-click="pointClickHandlerOne"
        :diameter="0.625"
        :customize-point="customizePoint"
        :customize-label="customizeLabel"
        :inner-radius="0.41275"
        center-template="centerTemplate2"
      >
        <DxSeries argument-field="dueText" value-field="dueCount" color="blue">
          <!-- <DxSmallValuesGrouping :top-count="100" mode="topN" /> -->
          <!-- <DxLabel :visible="true" :customize-text="customizeLabel" format="fixedPoint"  background-color="none" >
          <DxConnector :visible="true" :width="3" />
        </DxLabel> -->
          <DxLabel :visible="true" :customize-text="formatLabel" position="columns">
            <DxConnector :visible="true" :width="2.5" />
            <DxFont :size="18" />
          </DxLabel>
          <DxHoverStyle color="#007BFF" />
          <DxSelectionStyle color="#87c1ff" border="true" border-color="yellow" />
        </DxSeries>
        <DxExport :enabled="true" />

        <DxLegend horizontal-alignment="center" vertical-alignment="center" @legend-click="onLegendClick" />
        <template #centerTemplate2="data">
          <!-- {{ data }} -->
        </template>
      </DxPieChart>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, toRaw } from "vue";
import { useStoreWorkList } from "@/stores/workListsStore";

import DxPieChart, {
  DxLegend,
  DxSeries,
  DxExport,
  DxHoverStyle,
  DxSelectionStyle,
  DxSmallValuesGrouping,
  DxTooltip,
  DxFormat,
  DxLabel,
  DxConnector,
  DxAnnotation,
  DxCommonSeriesSettings,
  DxSize,
} from "devextreme-vue/pie-chart";

const AreIdsShown = ref(true);
const isOpen = ref(true);
const workListStore = useStoreWorkList();

// & PROPS
const props = defineProps({
  widgetType: {
    type: Number,
    Default: () => {},
    required: true,
  },
  widget: {
    type: Object,
    Default: () => {},
  },
  widgetDetail: {
    type: Object,
    Default: () => {},
  },
});

function pointClickHandlerOne({ target }) {
// console.log("pointClickHandlerOne");
  // toastrError(' pointClickHandlerOne ')
// console.log("target");
// console.log(target);

// console.log("STUB in SELECTED obj DATA element  >>> Send to STORE >>");

// console.log("target.data");
// console.log(target.data);
  // console.log(target.data.percent)

  const seleWid = target.data;

// console.log(target.data.dueText);

  // target.select()

  if (target.isSelected()) {
    target.clearSelection();
// console.log(" STORE SET Mut 														setSelectedSummaryWidget  ");
    // ST set
    // this.$store.commit("reSetWIdgetFilter");
    workListStore.reSetWIdgetFilter();
  } else {
    target.select();
// console.log(" STORE SET Mut 														setSelectedSummaryWidget  ");
    // ST set
    // this.$store.commit("setWIdgetFilter", seleWid.dueText);
    workListStore.setWIdgetFilter(seleWid.dueText);

// console.log("this.selectedWidgetFilter");
// console.log(this.selectedWidgetFilter);
  }
}
function customizePoint(pointInfo) {
  // console.log(' customizePoint pointInfo')

  // console.log(pointInfo)
  // console.log(pointInfo.value)

  if (pointInfo.argument === "Today") {
    return pointInfo.argument === "Today" ? { color: "#83facf" } : {};
  } else if (pointInfo.argument === "Next 7 Days") {
    return pointInfo.argument === "Next 7 Days" ? { color: "#fbe7b7" } : {};
  } else if (pointInfo.argument === "Next 8-14 Days") {
    return pointInfo.argument === "Next 8-14 Days" ? { color: "#e2d0a5" } : {};
  } else if (pointInfo.argument === "Next 15-30 Days") {
    return pointInfo.argument === "Next 15-30 Days" ? { color: " #c9b992" } : {};
  } else if (pointInfo.argument === "Next 31-90 Days") {
    return pointInfo.argument === "Next 31-90 Days" ? { color: "#808eb0" } : {};
  } else if (pointInfo.argument === "Next Year") {
    return pointInfo.argument === "Next Year" ? { color: "#495164" } : {};
  } else if (pointInfo.argument === "Overdue") {
    return pointInfo.argument === "Overdue" ? { color: "#ff8e8e" } : {};
  } else return pointInfo.value ? { color: "#fcecc5" } : {};
}
function customizeLabel(point) {
  // console.log(' customizeLabel point')
  // console.log(point)
  // console.log(point.data.dueText)

  // console.log(point.argument)
  // console.log(point.data.dueText)

  if (point.argument === "Today") {
    return point.argument === "Today" ? { backgroundColor: "", font: { color: "#004BFF", size: "10px" } } : {};
  } else if (point.argument === "Next 7 Days") {
    return point.argument === "Next 7 Days" ? { backgroundColor: "", font: { color: "#123486", size: "10px" } } : {};
  } else if (point.argument === "Next 8-14 Days") {
    return point.argument === "Next 8-14 Days" ? { backgroundColor: "", font: { color: "#123486", size: "10px" } } : {};
  } else if (point.argument === "Next 15-30 Days") {
    return point.argument === "Next 15-30 Days" ? { backgroundColor: "", font: { color: "#eef8ef", size: "10px" } } : {};
  } else if (point.argument === "Next 31-90 Days") {
    return point.argument === "Next 31-90 Days" ? { backgroundColor: "", font: { color: "#eef8ef", size: "10px" } } : {};
  } else if (point.argument === "Next Year") {
    return point.argument === "Next Year" ? { backgroundColor: "", font: { color: "#eef8ef", size: "10px" } } : {};
  } else if (point.argument === "Overdue") {
    return point.argument === "Overdue" ? { backgroundColor: "", font: { color: "#eef8ef", size: "16px" } } : {};
  } else return point.argument ? { backgroundColor: "white", font: { color: "red" } } : {};
}
function onPointSelectionChanged({ target: point }) {
// console.log("                   onPointSelectionChanged");
// console.log();

  if (point.isSelected()) {
    this.isOpen = true;

    // Commands to execute when the point is selected
    // console.log(' POINT  is SELECTED ')
    // console.log(point.data.lastName + '  :   ' + point.data.firstName + ' TaskCount: ' + point.data.taskCount)

    // console.dir(point.data.id)
    // console.dir(point.data.personId)
    // console.log('----------------------')

    // console.log(' STORE SET Mut 														setSelectedSummaryWidgetDetail  ')
    // // ST set
    // // this.$store.commit('setSelectedSummaryWidgetDetail', point.data)
    // this.$store.commit('setPatientId', point.data.personId)
    // this.$store.dispatch('getPatientById', point.data.personId)
    // this.$store.dispatch('getPatientDXCodes', point.data.personId)

    // this.$store.commit('getPatientById', point.data.id)

    // var tTemp=        this.recordsSelectedDashHandler(point.data.id)
    //   console.log(tTemp)
  } else {
    this.isOpen = false;
    // Commands to execute when the selection is cleared
  }
}
function formatLabel(pointInfo) {
  // console.log(pointInfo)
  return `${pointInfo.point.data.dueText}: ${pointInfo.valueText}`;
}
function onLegendClick({ points }) {
  // console.clear()
// console.log("onLegendClick");

  // for a single-series PieChart
  points[0].isVisible() ? points[0].hide() : points[0].show();

  /* for a multi-series PieChart
	points.forEach(function (point) {
			point.isVisible() ? point.hide() : point.show();
	});
	*/
}

onMounted(() => {
// console.log("onMounted() :      WidgetDoughnutChart >>>>");

// console.log(" prop   WIDGET ");
// console.log("props : ");
// console.log(props);
// console.log(props.widgetType);
// console.log(props.widget);
// console.log(props.widgetDetail);

  // console.log({...props});
  // console.log(toRaw(props));
// console.log({ ...props.widgetType });
  // console.log(toRaw(props.widgetType));
// console.log({ ...props.widget });
  // console.log(toRaw(props.widget));
// console.log({ ...props.widgetDetail });
  // console.log(toRaw(props.widgetDetail));
});
</script>

<style scoped></style>
